<template>
    <a-layout class="layout" style="background: #000 !important">
      <header-section :customer-service-link="customerServiceLink" />
      
      <a-layout-content class="content">
        <div class="title glow-box">
          <h1>{{ pageTitle }}</h1>
          <p>{{ pageSubtitle }}</p>
        </div>
        
        <exchange-card />

        <div style="background: #000;">
            <faq-section />
        </div>
        
       
      </a-layout-content>
      
      <a-layout-footer class="footer">
        @ TRX自助服务平台
      </a-layout-footer>
    </a-layout>
  </template>
  
  <script>
  import HeaderSection from '@/components/HeaderSection.vue'
  import ExchangeCard from '@/components/ExchangeCard.vue'
  import FaqSection from '@/components/FaqSection.vue'
  import { initSpecialProductPage } from '../util/specialProduct'
  
  export default {
    components: {
      HeaderSection,
      ExchangeCard,
      FaqSection
    },
    data() {
      return {
        customerServiceLink: '#',
        pageTitle: 'USDT自动兑换TRX',
        pageSubtitle: '7*24小时自动兑换',
        specialProduct: null,
      }
    },
    mounted() {
      initSpecialProductPage(this, 'trx_exchange', {
        titleField: 'pageTitle',
        subtitleField: 'pageSubtitle',
        fallback: {
          title: 'USDT自动兑换TRX',
          detail: '7*24小时自动兑换',
        },
      });
    }
  }
  </script>
  
  <style lang="less" scoped>
  .layout {
    min-height: 100vh;
    background: linear-gradient(180deg, #0a1a2f 0%, #1e2a44 100%);
  }
  
  .content {
    padding: 0 0;
    margin: 0 auto;
    max-width: 1200px;
    background:#1e2a44
  }
  
  .title {
    text-align: center;
    padding: 40px 20px;
    background: linear-gradient(180deg, #0a1a2f 0%, #1e2a44 100%);
    box-shadow: inset 0 0 20px rgba(0, 255, 255, 0.3);
    animation: glow 5s infinite;
    
    h1 {
            color: #FFF;
            margin: 0;
            font-weight: bold;
            text-shadow: 0 0 10px rgba(0, 170, 255, 0.5);
     
    }
    
    p {
      font-size: 1.1em;
      color: #d0d8e0;
      margin-top: 10px;
      text-shadow: 0 0 5px rgba(0, 170, 255, 0.3);
    }
  }
  
  .footer {
  width: 100%; // 关键修复：使用百分比宽度而非视口高度
  text-align: center;
  background: rgba(10, 26, 47, 0.9) !important;
  color: #d0d8e0;
  padding: 20px;
  
  // 确保布局正确
  display: block;
  margin: 0;
  box-sizing: border-box;
  
  // 针对Ant Design的特定修复
  &.ant-layout-footer {
    padding: 20px 50px; // Ant Design默认有水平padding
  }
}
  
  @media (max-width: 768px) {
    .title {
      padding: 20px 10px;
      
      h1 {
        font-size: 2em;
      }
      
      p {
        font-size: 1em;
      }
    }
  }
  </style>